export const LocalStorageKeys = {
    lastReloadTime: 'lastReloadTime',
    showSignInPage: 'showSignInPage',
};
